'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styles = {
  "InlineError": "Polaris-InlineError",
  "Icon": "Polaris-InlineError__Icon"
};

exports.default = styles;
